<template>
	<div>
		<div class="close-btn" v-on:click="close">
			<i title="close" class="material-icons md-18">close</i>
		</div>
		<div class="title">SHARE</div>
		<div class="px-3 py-2">
			<div class="category">
				<div class="category-title">LINK</div>
				<div class="property-row">
					<div class="text-description">{{link}}</div>
					<div class="pt-2">
						<button v-if="!copied" class="btn btn-dark btn-sm" v-on:click="copyLink">
							Copy
						</button>
						<button v-else class="btn btn-green btn-sm">
							<i class="material-icons md-18" style="margin-top:-3px;">assignment_turned_in</i>
							Copied to clipboard
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name:'share',
	props: {
		link:String,
	},
	computed:{
		layerId: function(){
			return this.feature.layer.id;
		}
	},
	created:function(){

	},
	data:function(){
		return {
			copied:false
		};
	},
	methods:{
		copyLink:function(){
			this.$copyText(this.link).then((e)=>{
				this.copied = true;
				setTimeout(()=>{
					this.copied = false;
				},800);
			},(e)=>{
				this.$store.dispatch('ERROR_MESSAGE_SET', {message:'Error copying to clipboard'});
				this.copied = false;
			});
		},
		close:function(){
			this.$emit('close');
		}
	}
};

</script>


// WEBPACK FOOTER //
// src/components/content/content-share.vue